const isAbsoluteURL = (url) =>
  url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//');

export default isAbsoluteURL;
